/* eslint-disable */

import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import type { EventEmitter } from "@/domains/library"
import { gaugeAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

export const claimLpReward = async ({
  account,
  chainId,
  config,
  gaugeAddress,
  tokenAddress,
}: {
  account: Address
  chainId: number
  config: Config
  gaugeAddress: Address
  tokenAddress: string
}): Promise<TransactionReturnType> => {
  try {
    // Parse the comma-separated string into an array of addresses
    const tokenAddresses = tokenAddress.includes(",")
      ? tokenAddress.split(",").map((addr) => addr.trim() as Address)
      : [tokenAddress as Address]

    console.log("Token addresses for claim:", tokenAddresses)

    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: gaugeAbi as Abi,
        account,
        address: gaugeAddress,
        args: [account, tokenAddresses], // Pass the array of addresses
        chainId,
        functionName: "getReward",
      },
    })
    return result
  } catch (error: any) {
    console.error("claimLpReward", error)
    return { success: false, error: error.message, code: error.code }
  }
}

export type ClaimLpRewardInteractionParams = {
  account: string
  chainId: number
  config: Config
  gaugeAddress: string
  tokenAddress: string
  tokenAddresses?: string[]
  pairDisplayName: string
  emitter: EventEmitter<any>
}

export const claimLpRewardInteraction = async ({
  account,
  chainId,
  config,
  gaugeAddress,
  tokenAddress,
  pairDisplayName,
  emitter,
}: ClaimLpRewardInteractionParams) => {
  // Parse the comma-separated addresses and ensure they're properly formatted
  const tokenAddresses = tokenAddress.includes(",")
    ? tokenAddress.split(",").map((addr) => addr as `0x${string}`)
    : [tokenAddress as `0x${string}`]

  // Rest of the implementation
  // ...
}
